import { getCountryList } from "@/services/public.services";
import { CountryList } from "@/types/global";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../store";
import axios from "axios";

interface GlobalState {
  countries: {
    isLoading: boolean;
    error: string | null;
    data: CountryList[];
  };
  userLocation: {
    isLoading: boolean;
    error: string | null;
    data: UserLocation | null;
  };
}

const initialState: GlobalState = {
  countries: {
    isLoading: false,
    error: null,
    data: [],
  },
  userLocation: {
    isLoading: false,
    error: null,
    data: null,
  },
};

interface UserLocation {
  ip: string;
  country: string;
  country_code: string;
  city: string;
  timezone: string;
  latitude: number;
  longitude: number;
}

export const fetchCountryList = createAsyncThunk("global/fetchCountryList", async (_, { rejectWithValue }) => {
  try {
    const response: any = await getCountryList();
    if (response?.status === 200) {
      if (response?.data?.response?.countries) {
        return response.data.response.countries;
      } else {
        return rejectWithValue("Country List Not Found!");
      }
    } else {
      return rejectWithValue("Failed to Fetch the Country List!");
    }
  } catch (error) {
    return rejectWithValue("Failed to Fetch the Country List!");
  }
});

export const fetchUserLocation = createAsyncThunk("global/fetchUserLocation", async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get("https://ipapi.co/json", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: false,
    });
    return response.data as UserLocation;
  } catch (error) {
    return rejectWithValue("Failed to fetch user location!");
  }
});

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    resetGlobalState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Country list cases
      .addCase(fetchCountryList.pending, (state) => {
        state.countries.isLoading = true;
        state.countries.error = null;
      })
      .addCase(fetchCountryList.fulfilled, (state, action) => {
        state.countries.isLoading = false;
        state.countries.data = action.payload;
        state.countries.error = null;
      })
      .addCase(fetchCountryList.rejected, (state, action) => {
        state.countries.isLoading = false;
        state.countries.error = action.payload as string;
      })
      // User location cases
      .addCase(fetchUserLocation.pending, (state) => {
        state.userLocation.isLoading = true;
        state.userLocation.error = null;
      })
      .addCase(fetchUserLocation.fulfilled, (state, action) => {
        state.userLocation.isLoading = false;
        state.userLocation.data = action.payload;
        state.userLocation.error = null;
      })
      .addCase(fetchUserLocation.rejected, (state, action) => {
        state.userLocation.isLoading = false;
        state.userLocation.error = action.payload as string;
      });
  },
});

export const { resetGlobalState } = globalSlice.actions;
export default globalSlice.reducer;

// Selector
export const globalSelector = (state: RootState) => state.global;
